module.exports = __webpack_public_path__ + "static/media/Picture3.d81c71fc.jpg";